<template>
  <div class="flex flex-col font-ds">
    <div class="px-6 pt-5 pb-4 border-b border-border">
      <div class="flex items-center gap-2.5 px-3.5 py-2.5 bg-accent rounded-ds-md">
        <Quote class="size-3.5 shrink-0 text-brand" />
        <p class="flex-1 min-w-0 text-sm font-medium text-accent-foreground">
          {{ sentence }}
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4 p-6">
      <p
        class="flex items-center gap-2 text-sm font-medium text-muted-foreground"
        aria-live="polite"
      >
        <Sparkles class="size-3.5 shrink-0 text-brand animate-pulse" />
        Reading your message…
      </p>

      <!--
        A skeleton of the shape that is coming — one record card with its
        fields — rather than a spinner, so the wait reads as the wizard being
        assembled and not as a request that might return anything at all.
      -->
      <div class="p-5 bg-card border border-border rounded-ds-lg shadow-ds-sm">
        <div class="flex gap-3 mb-4">
          <DSSkeleton class="size-9 shrink-0 rounded-ds-md" />
          <div class="flex-1 flex flex-col gap-2">
            <DSSkeleton class="h-3 w-24" />
            <DSSkeleton class="h-9 w-full" />
          </div>
        </div>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-x-5">
          <div
            v-for="field in FIELD_PLACEHOLDER_COUNT"
            :key="field"
            class="flex flex-col gap-2"
          >
            <DSSkeleton class="h-3 w-20" />
            <DSSkeleton class="h-9 w-full" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Quote, Sparkles } from '@lucide/vue'

import { DSSkeleton } from '@ds'

/*
 * What the wizard looks like before the assistant has answered. It knows
 * nothing about the flow — which is the point: the flow is what is being waited
 * for, so this must not imply one.
 */
defineProps<{
  /** What the user typed, shown back verbatim while they wait. */
  sentence: string
}>()

/** The smallest flow has this many fields; a skeleton that promises fewer would shrink. */
const FIELD_PLACEHOLDER_COUNT = 3
</script>
